<app-header [identifier]="identifier" [theme]="theme"></app-header>
<div class="masthead" [ngStyle]="{ 'background-color': theme.primaryColor }">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <h2 [ngStyle]="{ 'color': theme.textColor }">{{jobTitle}}</h2>
      </div>
    </div>
  </div>
</div>
<div class="wrapper">
  <div class="container">
    <div class="row">
      <div class="col-lg-3 col-md-4 col-sm-5 col-9 sidebar pt-3 pt-lg-5" [class.expanded]="expand === true">
        <div class="box p-0">
          <div class="text-right menuClose">
            <i class="fa fa-close" (click)="expand=!expand"></i>
          </div>
          <app-yellow-brick-road></app-yellow-brick-road>
        </div>
      </div>
      <div class="col-lg-9 col-md-12 pt-3 pt-lg-5">        
        <div class="menuToggle" (click)="expand=!expand">
          <span><i class="fa fa-bars"></i> Menu</span>
        </div>
        <router-outlet></router-outlet>
      </div>
    </div>
    <app-footer [theme]="theme"></app-footer>
  </div>
</div>